function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "10.017%",
  x2: "50%",
  y2: "100%",
  id: "profileOverlay_svg__a"
}, React.createElement("stop", {
  stopOpacity: 0,
  offset: "0%"
}), React.createElement("stop", {
  stopOpacity: 0.6,
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#profileOverlay_svg__a)",
  d: "M0 0h345v92H0z",
  transform: "translate(.142 -9.212)"
}), React.createElement("path", {
  d: "M313.88 57.848l-3.665 1.928.7-4.082a2.05 2.05 0 00-.56-1.726l-2.966-2.89 4.098-.596a2.05 2.05 0 001.468-1.066l1.833-3.71 1.832 3.71a2.05 2.05 0 001.467 1.066l4.094.6-2.96 2.886a2.05 2.05 0 00-.561 1.726l.709 4.086-3.675-1.932a2.05 2.05 0 00-1.814 0zm.887 1.764l4.57 2.403c1.218.64 2.393-.212 2.16-1.57l-.873-5.088c.009.049.023.004-.013.039l3.698-3.604c.985-.96.537-2.342-.825-2.54l-5.11-.742c.05.007.011-.021.033.024l-2.285-4.63c-.609-1.234-2.06-1.235-2.67 0l-2.285 4.63c.022-.045-.016-.017.033-.024l-5.11.742c-1.36.198-1.81 1.579-.824 2.54l3.697 3.604c-.036-.035-.021.01-.013-.04l-.873 5.09c-.232 1.356.942 2.21 2.16 1.569l4.57-2.403c-.044.024.004.024-.04 0z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

const SvgProfileOverlay = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 345,
  height: 83,
  viewBox: "0 0 345 83",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgProfileOverlay, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;